import { createSelector } from 'reselect'
import { createArraySelector } from 'reselect-map'

import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.RICH_TEXT_POLL,
	featureFlagsTypes.RICH_TEXT_MATH_FORMULAS_PLUGIN,
])

const pollSelector = state => state.poll
const questionsSelector = state => state.poll.questions

const questionsWithErrorsSelector = createArraySelector(
	[questionsSelector],
	qst => {
		const questionTextError = !qst.text && !qst.textTouched
		const answersError = qst.answers.filter(ans => ans.text === '' && !ans.textTouched).length > 0
		const hasErrors = questionTextError || answersError || !!qst.hasExceedChars

		return {
			...qst,
			textErrors: !qst.text ? 'Please include text for this question' : '',
			answers: qst.answers.map(ans => ({
				...ans,
				textErrors: !ans.text ? 'Please include text for this answer' : '',
			})),
			hasErrors,
		}
	}
)

const questionsExpandedSelector = createSelector(
	[questionsSelector],
	questions => questions.filter(question => !question.collapsed).length!==0
)

const creationToolContainerSelector = createSelector(
	[ pollSelector, questionsWithErrorsSelector, questionsExpandedSelector, featureFlagsSelector ],
	(pollState, questions, someExpanded, featureFlags) => ({
		...pollState,
		questions: questions.filter(question => question.status !== 'deleting'),
		someExpanded,
		canUseMultipleOptions: pollState.settings.allowMultipleOptions,
		shouldUseRichText: featureFlags[featureFlagsTypes.RICH_TEXT_POLL],
		shouldUseRichTextMathFormula: featureFlags[featureFlagsTypes.RICH_TEXT_MATH_FORMULAS_PLUGIN],
	})
)

export default creationToolContainerSelector
